import React from 'react';
import { MusicDistributionClientContext } from '../../context/MusicDistributionClientContext';
import { MusicAlbumEntity } from '../../types/MusicAlbumEntityTypes';
import { MusicEntity } from '../../types/MusicEntityTypes';
import MusicAlbumEditForm2AddPopupView from './MusicAlbumEditForm2AddPopupView';

export default function MusicAlbumEditForm2AddPopup({
  musicAlbum,
  onCancel,
  onDone,
} : {
  musicAlbum: MusicAlbumEntity,
  onCancel: () => void,
  onDone: () => void,
}) {
  const {
    getMusicAlbumTracks, getMusics, addMusicAlbumTracks,
  } = React.useContext(MusicDistributionClientContext);
  const [musics, setMusics] = React.useState<MusicEntity[]>([]);
  const [selectedMusics, setSelectedMusics] = React.useState<MusicEntity[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [page, setPage] = React.useState(0);

  const loadNextMusics = () => {
    setLoading(true);
    getMusics(page + 1).then((data) => {
      setLoading(false);
      setPage(page + 1);
      setMusics(musics.concat(data.musics));
    });
  };

  React.useEffect(() => {
    setLoading(true);
    getMusicAlbumTracks(musicAlbum.id).then((data) => {
      setLoading(false);
      const { musicAlbumTracks } = data;
      // eslint-disable-next-line max-len
      const initialSelectedMusics = musicAlbumTracks.map((musicAlbumTrack) => musicAlbumTrack.music);
      setSelectedMusics(initialSelectedMusics);
      loadNextMusics();
    });
  }, []);

  const handleSubmit = () => {
    if (selectedMusics.length > 0) {
      const selectedMusicIds = selectedMusics.map((selectedMusic) => selectedMusic.id);
      addMusicAlbumTracks(musicAlbum.id, selectedMusicIds).then((responseData) => {
        if (responseData.result) {
          onDone();
        }
      });
    } else {
      onCancel();
    }
  };

  return (
    <MusicAlbumEditForm2AddPopupView
      musics={musics}
      isMusicSelected={(music) => selectedMusics.filter((selectedMusic) => selectedMusic.id === music.id).length > 0}
      setMusicSelected={(music, selected) => {
        if (selected) {
          setSelectedMusics(selectedMusics.concat([music]));
        } else {
          setSelectedMusics(selectedMusics.filter((selectedMusic) => selectedMusic.id !== music.id));
        }
      }}
      isLoadingMore={loading}
      onReadMore={() => loadNextMusics()}
      onSubmit={() => handleSubmit()}
      onCancel={() => onCancel()}
    />
  );
}
